import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { useState } from 'react'
import { copyText } from 'util/clipboard'
import { delay } from 'util/promise'
import css from './CopyButton.module.scss'

type Props = {
  className?: string
  data: string | null | undefined
  size?: number
}

export function CopyButton(props: Props) {
  const { data } = props
  const [done, setDone] = useState(false)
  const className = clsx(props.className, css.copy, done && css.done)
  const name = done ? 'check' : 'content_copy'
  const size = props.size ?? 12

  const onClick = useLatestCallback(async () => {
    await copyText(data ?? '')
    setDone(true)
    await delay(1000)
    setDone(false)
  })

  return <Icon size={size} className={className} name={name} secondary onClick={onClick} />
}
